<template>
    <RPFilter
        ref="filter"
        class="ReviewSort"
        type="tertiary"
        :value="value"
        :options="options"
        default-label="Sort"
    >
        <span
            v-if="showSelection"
            class="ReviewSort__selection"
        >
            <StreamlineIcon
                class="ReviewSort__selection-icon"
                :icon="selection.icon"
                stroke="black"
                :size="12"
            />
            {{ selection.label }}
        </span>
        <div
            slot="dropdown"
            class="ReviewSort__dropdown"
        >
            <RPRadioContainer
                :value="value"
                :options="options"
                @click.stop=""
                @input="v => $emit('input', v)"
            />
        </div>
    </RPFilter>
</template>
<script>
import RPRadioContainer from 'components/Basic/FormElements/RPRadioContainer.vue';
import {ArrowUp, ArrowDown} from "@reviewpush/streamline-regular/lib/arrows-diagrams/Arrows";
import RPFilter from 'components/Complex/Filters/RPFilter.vue';
import {isEqual} from 'lodash';

export default {
    name: 'RPReviewSort',
    components: {
        RPFilter,
        RPRadioContainer
    },
    props: {
        value: {
            type: [String, Boolean, Object],
            required: true
        }
    },
    data(){
        return {
            options: [
                {
                    label: 'Review Age',
                    icon: ArrowUp,
                    value: {sort_by: '', sort_order: ''}
                },
                {
                    label: 'Review Age',
                    icon: ArrowDown,
                    value: {sort_by: 'review', sort_order: 'desc'}
                },
                {
                    label: 'Rating',
                    icon: ArrowUp,
                    value: {sort_by: 'rating', sort_order: 'asc'}
                },
                {
                    label: 'Rating',
                    icon: ArrowDown,
                    value: {sort_by: 'rating', sort_order: 'desc'}
                },
                {
                    label: 'Response Age',
                    icon: ArrowUp,
                    value: {sort_by: 'response', sort_order: 'asc'}
                },
                {
                    label: 'Response Age',
                    icon: ArrowDown,
                    value: {sort_by: 'response', sort_order: 'desc'}
                },
                {
                    label: 'Review Length',
                    icon: ArrowUp,
                    value: {sort_by: 'length', sort_order: 'asc'}
                },
                {
                    label: 'Review Length',
                    icon: ArrowDown,
                    value: {sort_by: 'length', sort_order: 'desc'}
                },
            ]
        };
    },
    computed: {
        selection(){
            return this.options.find(opt => isEqual(this.value, opt.value));
        },
        showSelection(){
            return this.selection && this.options.findIndex(opt => isEqual(this.value, opt.value)) !== 0;
        },
    },
    watch: {
        value(newVal, oldVal){
            if(!isEqual(newVal,oldVal)){
                this.$refs.filter.close();
            }
        }
    }
};
</script>
<style lang="scss">
    .ReviewSort {
        &__dropdown {
            margin: 0.5rem;
        }
        &__selection {
            color: $text-grey;
            display: flex;
            align-items: center;
            white-space: nowrap;
            &-icon {
                margin-right: 0.25rem;
            }
        }
    }
</style>
